export const HOLIDAY_REQUEST_CONSTANTS = {
    HOLIDAY_APPROVE_REQUEST_TYPE: 'approve-requests',
    HOLIDAY_REJECT_REQUEST_TYPE: 'reject-requests',
    HOLIDAY_DELETE_REQUEST_TYPE: 'delete-requests',
}

export const TALENT_REQUEST_CONSTANTS = {
    TALENT_REQUEST_COUNT_TYPE: 'Open'
}
